export default "__VITE_ASSET__BchegStB__"